export const GOODRX = 'GoodRx';
export const DEFAULT_SOCIAL_IMAGE = {
  __typename: 'Asset',
  height: 292,
  title: 'Image',
  url: 'https://www.grxstatic.com/mobile/11952a8471955e3956ea01eca4a61b0c365e945c/dist/e90410a38dcda82b9e4136798aa528b8.png',
  width: 560
};